import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Box, IconButton, Menu, MenuItem, Button,Typography  } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TodayIcon from "@mui/icons-material/Today";

import CategoryList from "../components/CategoryList";
import { supabase } from "../supabaseClient";
import UserProfile from "../components/UserProfile";
import NotificationList from "../components/NotificationList";
import FixedBottomNavigation from "../components/FixedBottomNavigation";
import EventIcon from "@mui/icons-material/Event";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
// 🔹 최상단 import 영역에 추가
import AlarmSettingsDialog from "../components/AlarmSettingsDialog";

const Main = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null); // 메뉴 열림 상태 관리
  const open = Boolean(anchorEl);
  const [alarmDialogOpen, setAlarmDialogOpen] = useState(false); // ✅ Dialog 상태
  const [alarmEnabled, setAlarmEnabled] = useState(true); // ✅ 알람 설정 상태

  useEffect(() => {
    let isMounted = true; // ✅ 컴포넌트가 언마운트되었는지 체크

    // ✅ onAuthStateChange 구독 및 클린업 처리
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      if (isMounted) setUser(session?.user ?? null);
    });

    return () => {
      isMounted = false; // ✅ 언마운트 시 API 호출 막기
      subscription?.unsubscribe(); // ✅ 구독 해제
    };
  }, []);

  const currentDate = new Date().toLocaleDateString("ko-KR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // 메뉴 핸들러
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    navigate("/home");
  };

  const handleAlarmToggle = (event) => {
    setAlarmEnabled(event.target.checked);
    // 여기서 supabase update 가능
  };

  return (
    <Container sx={{pb:8, pl:2, pr:2, pt:1}}>
      {/* 상단 바 */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        {/* 메뉴 버튼 (왼쪽 상단) */}
        <Box sx={{display:"flex",flexDirection:"row",gap:0.5,alignItems:"center"}}>
          <IconButton onClick={handleMenuOpen}><MenuIcon /></IconButton>
          <Typography variant="subtitle1" fontWeight="bold" color="text.secondary" sx={{lineHeight:1.1}}>엄빠어디가</Typography>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={handleMenuClose}>홈</MenuItem>
          <MenuItem onClick={()=>navigate("/setting")}>설정</MenuItem>
          <MenuItem onClick={()=>navigate("/places")}>장소설정</MenuItem>
          <MenuItem onClick={handleMenuClose}>로그아웃</MenuItem>
        </Menu>
        {/* 날짜 표시 */}
        <Box sx={{display: "flex", alignItems: "center",gap:1}}>
          <CalendarTodayIcon sx={{ fontSize: 16, color: "grey" }} />
          <Box color="text.secondary">{currentDate}</Box>
        </Box>
      </Box>

      <Box sx={{ mt: 1 }}></Box>
      <UserProfile user={user} />

      {/* 예약 알람 및 스케줄 관리 버튼 */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt:2 }}>
        <Button
          variant="outlined"
          onClick={() => navigate("/profile")} // 🔹 클릭 시 이동
          startIcon={<EventIcon />}
          sx={{
            flex:1,
            borderRadius: 2,
            backgroundColor:'white',
            textTransform: "none",
            fontWeight: "bold",
            py: 1.5,
          }}
        >스케줄 관리</Button>

        <Button
          variant="outlined"
          color="primary"
          startIcon={<NotificationsActiveIcon />}
          onClick={() => setAlarmDialogOpen(true)}
          sx={{
            flex:1.1,
            borderRadius: 2,
            backgroundColor:'white',
            textTransform: "none",
            fontWeight: "bold",
            py: 1.5,
          }}
        >예약 알람 설정</Button>
      </Box>
      
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
        <Button
          variant="outlined" color="secondary" startIcon={<CalendarTodayIcon />}
          sx={{ flex:1,borderRadius: 2, px: 3, py: 1.5, backgroundColor:'white'}}
        >일정 만들기</Button>
        <Button 
          variant="outlined" color="secondary" startIcon={<TodayIcon />} 
          sx={{ flex:1.1,borderRadius: 2, px: 3, py: 1.5, backgroundColor:'white'}}
        >오늘 뭐하지?</Button>
      </Box>

      <CategoryList />
      <Box sx={{ mt: 1 }}></Box>
      <NotificationList />
      <FixedBottomNavigation />
      <AlarmSettingsDialog
        disableEnforceFocus
        open={alarmDialogOpen}
        onClose={() => setAlarmDialogOpen(false)}
        alarmEnabled={alarmEnabled}
        onToggle={handleAlarmToggle}
      />
    </Container>
  );
};

export default Main;
